import { render } from "./ScreenTime.vue?vue&type=template&id=5d58451a&scoped=true"
import script from "./ScreenTime.vue?vue&type=script&lang=js"
export * from "./ScreenTime.vue?vue&type=script&lang=js"

import "./ScreenTime.vue?vue&type=style&index=0&id=5d58451a&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d58451a"]])

export default __exports__